import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid" }
const _hoisted_2 = { class: "d-flex flex-row-fluid flex-center bg-white rounded" }
const _hoisted_3 = {
  class: "py-20 w-100 w-xl-700px px-9",
  novalidate: "novalidate",
  id: "kt_create_account_form"
}
const _hoisted_4 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_5 = { class: "d-flex justify-content-end flex-stack pt-10" }
const _hoisted_6 = { class: "svg-icon svg-icon-4 ms-1 me-0 indicator-label" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Step1, { onOnChangeAccountType: _ctx.onChangeAccountType }, null, 8, ["onOnChangeAccountType"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.routeToWizard && _ctx.routeToWizard(...args))),
              class: "btn btn-lg btn-primary",
              ref: "submitButton"
            }, [
              _createElementVNode("span", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
              ]),
              _hoisted_8
            ], 512)
          ])
        ])
      ])
    ])
  ]))
}